'use strict';
var parent = require('../../es/object/assign');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/object/assign.js
// module id = 772
// module chunks = 13